import type { PatientCardSource } from '@/components/patient-card/patient-card-data';
import { useQueryEncounterCard } from '@/features/my-patient/services/use-query-encounter-card';
import { useQueryPatientCard } from '@/features/my-patient/services/use-query-patient-card';

export const InisPatientCardSource: PatientCardSource = ({
  mrn,
  encounterId,
  children,
}) => {
  const patient = useQueryPatientCard(mrn, { enabled: true });
  const encounter = useQueryEncounterCard(encounterId, { enabled: true });

  return children({ patient, encounter });
};
